import * as React from 'react'

import getUrl from 'airship/modules/get-url'
import {getJourneyTemplates} from 'airship/modules/journeys-tools/templates'
import MessageType from 'airship/widgets/new-push-popover/message-type'

import {getUrlWithCreationSourceHints} from './utils'

interface Props {
  title?: string
}

const JourneyTemplateList: React.FC<Props> = ({title}) => {
  const templates = getJourneyTemplates(true)

  return (
    <div className="u-contain-spread-sm u-space-ends-6">
      {title && (
        <h2 className="u-flex u-flex-justify-between u-pad-top-2 u-text-shrink-1 u-text-uppercase u-text-bold u-grey-60">
          {title}
        </h2>
      )}
      <div className="grid grid--with-gutter">
        {templates.map(({templateName, title, icon, description}) => (
          <div
            className="grid-cell u-md-size-1of2 u-pad-top-1"
            key={templateName}
          >
            <MessageType
              key={templateName}
              href={getUrlWithCreationSourceHints(
                'series:series_from_template',
                getUrl.APP_KEY,
                templateName
              )}
              title={title}
              icon={icon}
              description={description}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default JourneyTemplateList
